import type { ReactNode } from "react";

interface OnboardFooterProps {
  left?: ReactNode;
  right?: ReactNode;
}

export const OnboardFooter = ({ left, right }: OnboardFooterProps) => (
  <div className="bg-background sticky bottom-0 z-10 flex items-center justify-between gap-2 border-t px-4 py-2">
    <div className="flex items-center gap-2">{left}</div>
    <div className="flex items-center gap-2">{right}</div>
  </div>
);
